.employee-label {
	display: flex;
	align-items: center;
	gap: 4px;
}

.crew-lead-indicator {
	flex: 0 0 4px;
	width: 4px;
	height: 4px;
	background-color: black;
}